import React from "react";
import { useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";
import { Button } from "./ui/button";
import { useBooking } from "../context/BookingContext";

const HIDE_ON = ["/login", "/register", "/checkin", "/dashboard", "/admin"];

export function MobileBookBar() {
  const { openBooking } = useBooking();
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-4 py-3 bg-white/85 backdrop-blur-md border-t border-black/5"
      data-testid="mobile-book-bar"
    >
      <Button
        onClick={() => openBooking()}
        data-testid="mobile-sticky-book-now"
        className="w-full iri-gradient text-ink font-medium rounded-full h-12 text-base hover:opacity-90 transition-opacity"
      >
        <Calendar className="h-4 w-4 mr-2" /> Book Now
      </Button>
    </div>
  );
}
